import React from 'react';
import  Nav from '../Nav';
import Navbar from '../Navbar';
import  Footer  from '../Footer/Footer';
import Pwani from './Pwani';

function Venue() {
  return (
    <div>
      <Nav />
      <Navbar />
      <div style={{marginTop: "100px"}}>
      <div className='prog_header'>
        <h1 className='prog_header_kippra'>6TH EDITION KIPPRA ANNUAL REGIONAL CONFERENCE  </h1>
        <h1 className='prog_header_theme'>THEME: ACCELERATING ECONOMIC GROWTH AND DEVELOPMENT FOR ASALS IN </h1>
      </div>
      </div>
      <div>
        <Pwani />
      </div>
     <div style={{marginTop: "30px"}}>
      <Footer />
     </div>
    </div>
  );
}

export default Venue;
